// @greenlight-spec: 15-database-schema.md
// @greenlight-spec: 17-code-organization.md
// What an app access entry — a named person or a bound group — is admitted as (ADR-0064).
export const APP_ACCESS_ROLES = ['viewer', 'editor'];
export const APP_TYPES = ['server'];
export const APP_STATUSES = [
    'registering',
    'registered',
    'building',
    'deploying',
    'active',
    'degraded',
    'failed',
    'suspended',
    'queued_for_deletion',
    'deleted',
];
/**
 * Statuses outside the live fleet: `registering`/`registered` are an app row
 * with nothing deployed behind it, and `deleted` is terminal (namespace gone,
 * repo archived). Everything else — including `queued_for_deletion` — still
 * has a workload someone operates.
 */
export const NON_LIVE_APP_STATUSES = ['registering', 'registered', 'deleted'];
/**
 * Statuses the kill switch can suspend from.
 *
 * Suspending cuts a running data plane — scale the pod to zero, revoke the data
 * keys — so it only means something for an app that reached a running state. A
 * pre-deploy status has no pod and no key yet, `failed` never got one, and
 * `deleted` is terminal.
 *
 * Shared because both sides of the action have to agree: the server refuses a
 * suspend from anything else, and a surface that offers the action anyway sends
 * the owner into an error it could have predicted.
 */
export const SUSPENDABLE_APP_STATUSES = ['active', 'degraded'];
/**
 * Takes `string` rather than `AppStatus` because several read schemas still type
 * `status` loosely; an unrecognised value is simply not suspendable, which is the
 * safe answer and keeps callers from casting to get an answer they then trust.
 */
export function isSuspendableAppStatus(status) {
    return SUSPENDABLE_APP_STATUSES.includes(status);
}
/**
 * Denylist rather than an allowlist so a status introduced later counts toward
 * the live fleet instead of silently disappearing from inventory totals.
 */
export function isLiveAppStatus(status) {
    return !NON_LIVE_APP_STATUSES.includes(status);
}
export const FLEET_BUCKETS = [
    'active',
    'deploying',
    'needs_attention',
    'suspended',
    'deleted',
];
export const BUCKET_STATUSES = {
    active: ['active'],
    deploying: ['registering', 'registered', 'building', 'deploying'],
    needs_attention: ['failed', 'degraded'],
    suspended: ['suspended'],
    deleted: ['deleted'],
};
/**
 * Columns the apps list can be ordered by on the server. Deliberately narrow: each key must
 * be a real `apps` column so the keyset cursor can encode a position in it. `usage` is absent
 * because per-app request counts are a separate aggregate, not a column — sorting by usage
 * stays page-local (docs/28 §/apps).
 *
 * `status` orders by lifecycle (the enum's own order: registering → … → deleted), not
 * alphabetically, so adjacent statuses read as adjacent stages.
 */
export const APP_SORT_KEYS = ['slug', 'status'];
export const SORT_DIRECTIONS = ['asc', 'desc'];
//# sourceMappingURL=app.js.map